module.exports = __webpack_public_path__ + "static/media/ticket.c18f16ce.svg";